// extracted by mini-css-extract-plugin
module.exports = {"blockButton":"Button_blockButton__2mVJx"};